export enum CuratedMediaListProperties {
  Name = "name",
  Description = "description",
  Active = "active",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  ProcessedMedia = "processedMedia",
  Released = "released",
  Media = "media"
}
export enum CuratedMediaListMetaProperties {}
